import React, { useEffect } from 'react';
import Switcher from './Switcher';
import Profile from './header/profile';
import ComponentsBreadcrumb from 'src/layout/componentsBreadcrumb';
import { useSelector } from 'react-redux';

const HeaderComponent = (props) => {
  const logoUrlData = useSelector(state => state.oidc?.logoUrls);
  useEffect(() => {
    if (props.userProfile?.role === "Customer") {
      window.open(process.env.REACT_APP_USER_URL, '_self');
    }
  }, [props.userProfile?.id]);
  return (
    <div className="md:mb-4 flex !bg-headerBg !py-3 sticky !top-0 w-full z-[999] border-b border-StrokeColor md:pr-0 header-bg-design">
      <div className='flex !justify-between  items-center  w-full'>
        <div className='flex-upto-tab text-start items-center flex justify-start'>
        {logoUrlData &&<div className=''>
            <img className='logo hidden dark:block w-[24px]' src={logoUrlData?.DarkThemeLogo} alt='Dark' />
            <img className='logo dark:hidden w-[24px]' src={logoUrlData?.WhiteThemeLogo} alt='White' />
          </div>}
          {logoUrlData && <span className='icon line-icon'></span>}
          <ComponentsBreadcrumb breadCrumbList={props.breadCrumbList} />
        </div>
        <div className='flex items-center justify-end gap-2.5 px-2'>
          <div className="hidden md:block">
            <Switcher />
          </div>
          <div className="hidden md:block">
            <Profile />
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeaderComponent;
